var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Component, Inject, Input, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { ResizableElementSettingModal } from '../base/resizable-element-setting-modal';
import { DefaultGraphCategories } from '../../core/settings/graph/default-graph-categories';
import { DEFAULT_GRAPH_SETTINGS } from '../../core/settings/graph/default-graph-settings';
import { ImageFillType } from '../../../view-data/components/image/image-fill-type';
import { DynamicDisplayModel } from '../../../../shared/dynamic-conduct-model/dynamic-display/dynamic-display-model';
import { ImageUrlHelper } from '../../diagram/utils/imageUrlHelper';
var ImageSettingModalComponent = /** @class */ (function (_super) {
    __extends(ImageSettingModalComponent, _super);
    function ImageSettingModalComponent(injector, defaultGraphSettings) {
        var _this = _super.call(this, injector, 'imageSettingModal') || this;
        _this.FillType = ImageFillType;
        _this.fillType = ImageFillType.Image;
        var settings = defaultGraphSettings ? defaultGraphSettings.settings.get(DefaultGraphCategories.Switch) : '';
        _this.defaultGraphId = settings ? settings.graphId : -1;
        return _this;
    }
    ImageSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        var imageData = editedComponent.model.data;
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        this.loadImageSetting(imageData);
        this.loadDynamicSetting(imageData);
    };
    ImageSettingModalComponent.prototype.loadImageSetting = function (imageData) {
        this.fillType = imageData.fillType ? imageData.fillType : ImageFillType.Image;
        this.imageId = imageData.imageId ? imageData.imageId : ImageUrlHelper.defaultImageId;
        this.graphSetting = imageData.graphSetting ? _.cloneDeep(imageData.graphSetting) : { id: this.defaultGraphId };
    };
    ImageSettingModalComponent.prototype.loadDynamicSetting = function (componentData) {
        if (null != componentData.dynamicSetting) {
            this.dynamicSetting = _.cloneDeep(componentData.dynamicSetting);
            DynamicDisplayModel.addDefaultForRotationTranslation(this.dynamicSetting);
        }
        else {
            this.dynamicSetting = DynamicDisplayModel.default();
        }
    };
    ImageSettingModalComponent.prototype.save = function () {
        this.currentDiagram.startTransaction('image settings');
        this.saving = true;
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(1);
            return;
        }
        this.saveImageSetting();
        this.saveDynamicSetting();
        this.currentDiagram.commitTransaction('image settings');
        this.close();
    };
    ImageSettingModalComponent.prototype.saveImageSetting = function () {
        this.saveComponentProperty('fillType', this.fillType);
        switch (this.fillType) {
            case ImageFillType.Image:
                this.saveComponentProperty('imageId', this.imageId);
                this.deleteComponentProperty('graphSetting');
                break;
            case ImageFillType.Graph:
                this.deleteComponentProperty('imageId');
                this.saveComponentProperty('graphSetting', this.graphSetting);
                break;
        }
    };
    ImageSettingModalComponent.prototype.saveDynamicSetting = function () {
        if (!this.dynamicValidatoinResult) {
            if (this.dynamicSetting.isTranslation !== true) {
                this.dynamicSetting.horizontalTranslation = null;
                this.dynamicSetting.verticalTranslation = null;
            }
            else {
                if (this.dynamicSetting.isHorizontalTranslation !== true) {
                    this.dynamicSetting.horizontalTranslation = null;
                }
                if (this.dynamicSetting.isVerticalTranslation !== true) {
                    this.dynamicSetting.verticalTranslation = null;
                }
            }
            if (this.dynamicSetting.isRotation !== true) {
                this.dynamicSetting.rotation = null;
            }
            this.saveComponentProperty('dynamicSetting', this.dynamicSetting);
        }
        else {
            this.notify.error(this.l('Savedfail'));
        }
    };
    ImageSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    ImageSettingModalComponent.prototype.validateChange = function (validatoinResult) {
        this.dynamicValidatoinResult = validatoinResult;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], ImageSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], ImageSettingModalComponent.prototype, "staticTabs", void 0);
    __decorate([
        Input()
    ], ImageSettingModalComponent.prototype, "viewWidth", void 0);
    __decorate([
        Input()
    ], ImageSettingModalComponent.prototype, "viewHeight", void 0);
    ImageSettingModalComponent = __decorate([
        Component({
            selector: 'image-setting-modal',
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"imageSettingModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" (onHidden)=\"onHidden()\" [config]=\"{backdrop: 'static'}\"> <div class=\"modal-dialog\" style=\"min-width: 600px;\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <form class=\"configure\" *ngIf=\"active\" #imageSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Image\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle design-nav-link\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('Setting')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-radio-select-header\"> <label for=\"FillType_Image\"> <input id=\"FillType_Image\" name=\"FillType\" [(ngModel)]=\"fillType\" [value]=\"FillType.Image\" type=\"radio\"> <span>{{lc(\"ViewFillType_Image\")}}</span> </label> <label for=\"FillType_Graph\"> <input id=\"FillType_Graph\" name=\"FillType\" [(ngModel)]=\"fillType\" [value]=\"FillType.Graph\" type=\"radio\"> <span>{{lc(\"ViewFillType_Graph\")}}</span> </label> </div> <div [ngSwitch]=\"fillType\"> <div class=\"fe-modal-body\" *ngSwitchCase=\"FillType.Image\"> <fc-image-uploader [(imageId)]=\"imageId\"></fc-image-uploader> </div> <div *ngSwitchCase=\"FillType.Graph\"> <graph-setting [hiddenUseGraph]=\"true\" [configureId]=\"configureId\" [loadOnInit]=\"true\" [useGraph]=\"true\" [graphSetting]=\"graphSetting\"></graph-setting> </div> </div> </tab> <tab heading=\"{{lc('DynamicSetting')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(dynamicSettingEventName,configureId)\"> <dynamic-conduct [dynamicSetting]=\"dynamicSetting\" [configureId]='configureId' [viewWidth]=\"viewWidth\" [viewHeight]=\"viewHeight\" (validateChange)=\"validateChange($event);\"></dynamic-conduct> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isFixedPositionVisible]='true'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!imageSettingForm.form.valid || dynamicValidatoinResult\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        }),
        __param(1, Inject(DEFAULT_GRAPH_SETTINGS))
    ], ImageSettingModalComponent);
    return ImageSettingModalComponent;
}(ResizableElementSettingModal));
export { ImageSettingModalComponent };
